import React from "react";
import "./BackgroundGradients.css";

export default function BackgroundGradients() {
  return (
    <div className="bg-gradients" aria-hidden="true">
      <div className="g-ball g1" />
      <div className="g-ball g2" />
      <div className="g-ball g3" />
      <div className="g-ball g4" />
      <div className="g-ball g5" />
      <div className="g-ball g6" />
    </div>
  );
}
